import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Menu from 'components/Menu'
import Wrapper from 'components/Wrapper'
import Head from 'components/Head'
import 'style/main.less'
import Helmet from "react-helmet"
import { config } from 'config'

export default function Template({ children }) {
    let headImage;
    let hasFrame = children.props.route.page && !children.props.route.page.data.headImageNoFrame;

    if (children.props.route.page) {
        headImage = children.props.route.page.data.headImage;
    } else if (children.props.location.pathname.indexOf('/programm') !== -1) {
        headImage = 'programm.png';
        hasFrame = false;
    }

    return (
        <Wrapper>
            <Helmet
                title={config.siteTitle}
                meta={[
                    { "name": "description", "content": "Golden City Hafenbar Bremen" }
                ]}
            />
            <Head image={headImage} hasFrame={hasFrame} />
            <Menu route={children.props.location.pathname} />
            {children}
        </Wrapper>
    )
}


// WEBPACK FOOTER //
// ./_template.jsx